import { Component, OnInit } from '@angular/core';
import { BlobFileDownloadRequestModel } from '../../../models/blob-file-sas-url.model';
import { MSAIDownloadCSV } from '../../../models/msai-download-csv.model';
import { AppConstants } from '../../common/app-constants';
import { CommonSharedModule } from '../../common/shared.module';
import { ExportService } from '../../services/export.service';
import { MSAIDownloadReportService } from '../../services/msai-download-report.service';

@Component({
  selector: 'app-msai-download-csv',
  templateUrl: './download-csv.component.html',
  styleUrls: ['./download-csv.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class MSAIDownloadCsvComponent implements OnInit {
  notificationMessage: any[] = [];
  downloadCSV!: MSAIDownloadCSV[];
  loadingIcon = 'fa-circle-o-notch';
  loading = false;
  selectedItem!: MSAIDownloadCSV;
  cols: any;
  excelLoadingReadyforPayment = false;
  excelLoadingNoPayeeID = false;
  hasError = false;

  constructor(
    private service: MSAIDownloadReportService,
    private exportService: ExportService
  ) {}

  ngOnInit() {
    this.getDownloadCSV();
    this.loading = true;
  }

  getDownloadCSV() {
    this.service.getMSAIDownloadCSVFilesList().subscribe(downloadReport => {
      this.downloadCSV = downloadReport;
      this.loading = false;
    });
  }

  public downloadFile(selectedFile: MSAIDownloadCSV) {
    const blobFileDownloadRequestModel: BlobFileDownloadRequestModel = {
      fileName: selectedFile.fileName || '',
      fileUrl: selectedFile.url || ''
    };

    this.service
      .getMSAIDownloadCSVFile(blobFileDownloadRequestModel)
      .subscribe(downloadFileSasUrl => {
        window.location.href = downloadFileSasUrl;
      });
  }

  async exportNoPayeeIDPaymentReport() {
    this.excelLoadingNoPayeeID = true;
    await this.exportReport(false);
    this.excelLoadingNoPayeeID = false;
  }

  async exportReadyforPaymentReport() {
    this.excelLoadingReadyforPayment = true;
    await this.exportReport(true);
    this.excelLoadingReadyforPayment = false;
  }

  async exportReport(hasPayeeId: boolean) {
    const excelData = await this.service
      .getMSAIPReadyforPaymentReport(hasPayeeId)
      .toPromise();
    if (excelData && excelData.length > 0) {
      const name =
        hasPayeeId == true
          ? 'Ready For Payment'
          : 'No Payee ID Ready For Payment';
      this.exportService.exportExcel(excelData, name);
    } else {
      this.hasError = true;
      this.showNotificationMessage(AppConstants.emptyRecordMsg, 'error');
    }
  }
  showNotificationMessage(message: string, severity = 'error') {
    this.notificationMessage = [];
    this.notificationMessage.push({
      severity: severity,
      detail: message,
      closable: false,
      sticky: true
    });
    setTimeout(() => {
      this.notificationMessage = [];
    }, 6000);
  }
}
